import { ClerkProvider } from "@clerk/clerk-react";
import { Outlet, useNavigate } from "react-router";
import { Toaster as Sonner } from "sonner";
import { QueryClientProvider } from "@tanstack/react-query";
import { env } from "@utils";
import { queryClient } from "@/utils/query";
import { WorkspacesWrapper } from "@/components/wrapper";

export default function App() {
   const navigate = useNavigate();
   return (
      <ClerkProvider
         publishableKey={env.VITE_CLERK_PUBLISHABLE_KEY}
         afterSignOutUrl="/"
         signInUrl="/"
         routerPush={(url) => navigate(url)}
         routerReplace={(url) => navigate(url, { replace: true })}
      >
         <QueryClientProvider client={queryClient}>
            <WorkspacesWrapper>
               <Outlet />
            </WorkspacesWrapper>
         </QueryClientProvider>
         <Sonner
            className="group toaster"
            toastOptions={{
               classNames: {
                  toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
                  description: "group-[.toast]:text-muted-foreground",
                  actionButton:
                     "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
                  cancelButton:
                     "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
               },
            }}
         />
      </ClerkProvider>
   );
}
